import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ApiResponse } from "../../api";
import NoDataDialog from "../dialogs/ErrorDialog";

interface Props<T>{
    run: boolean;
    setRun: (value: React.SetStateAction<boolean>) => void
    pending: boolean;
    setIsPending: (value: React.SetStateAction<boolean>) => void
    req: (...args: any[]) =>  Promise<ApiResponse<T>>;
    setData: (value: React.SetStateAction<T>) => void
    setShowError?: (value: React.SetStateAction<boolean>) => void
    storeError?: (value: React.SetStateAction<number>) => void
}

function APIRequest<T> ({ run, setRun, pending, setIsPending, req, setData, setShowError, storeError }: Props<T>): React.ReactElement  {
    const history = useHistory();
    const [open, setIsOpen] = useState(false);
    const [text, setText] = useState("");

    useEffect(() => {
        const getData = async () => {
            setIsPending(true);
            const res = await req();
            if (res.errorStatus && res.errorMessage) {
                if (res.errorStatus === 401) {
                  history.push("/login");
                  return;
                }
                setText(res.errorStatus + ": " + res.errorMessage)
                setIsOpen(true);
                setRun(false);
                setIsPending(false);
                if (setShowError) setShowError(true)
                if (storeError) storeError(res.errorStatus)
                return;
              }
              if (!res) {
                history.push("/login");
                return;
              } else {
                if (!res.data) {
                    setText("Der er ingen data")
                    setIsOpen(true);
                    setRun(false);
                    setIsPending(false);
                    return;
                }
                setData(res.data);
              }
            setRun(false);
            setIsPending(false);
        }
        if (run && !pending) {
            getData();
        }
    });

    return (
        <NoDataDialog open={open} onClose={() => setIsOpen(false)} title={"Der skete en fejl"} text={text}/>
    );
}

export default APIRequest;